import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { loginUser } from "../store/authSlice";
import { STATUSES } from "../globals/misc/statuses";

const Login = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.auth);
  const loading = status === STATUSES.LOADING;
  const from = location.state?.from || "/";

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ok = await dispatch(loginUser(credentials));
    if (ok) navigate(from, { replace: true });
  };

  return (
    <div className="relative flex min-h-[80vh] items-center justify-center px-4 py-16">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(26,68,144,0.18),_transparent_55%)]" />
      <div className="relative w-full max-w-md animate-rise">
        <div className="mb-8 text-center">
          <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-amber-600">
            Welcome back
          </p>
          <h1 className="font-display text-4xl font-bold text-navy-900">
            Sign in
          </h1>
          <p className="mt-2 text-navy-800/70">
            Track reports and help keep roads safer.
          </p>
        </div>

        <div className="rounded-2xl border border-navy-900/10 bg-white/90 p-8 shadow-[0_20px_60px_rgba(11,31,68,0.08)] backdrop-blur">
          <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-navy-900">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={credentials.email}
                onChange={handleChange}
                className="w-full rounded-xl border border-navy-900/15 bg-surface px-4 py-2.5 outline-none transition focus:border-navy-700 focus:ring-2 focus:ring-navy-700/20"
              />
            </div>

            <div>
              <label htmlFor="password" className="mb-1.5 block text-sm font-medium text-navy-900">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={credentials.password}
                onChange={handleChange}
                className="w-full rounded-xl border border-navy-900/15 bg-surface px-4 py-2.5 outline-none transition focus:border-navy-700 focus:ring-2 focus:ring-navy-700/20"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-xl bg-navy-900 py-3 text-sm font-semibold text-white transition hover:bg-navy-800 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-navy-800/70">
            Don&apos;t have an account?{" "}
            <Link to="/register" className="font-semibold text-amber-600 hover:text-amber-500">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
